import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { CatalogPicker } from "./CatalogPicker";
import { api, errorMessage } from "../lib/api";

const REASONS = [["prezzo", "Prezzo"], ["ha già un gestionale", "Ha già un gestionale"],
  ["non ha tempo", "Non ha tempo"], ["non decide lui", "Non decide lui"], ["altro", "Altro"]];
const PRODUCT_CODES = ["interested", "enrolled", "later"];

export const OutcomeForm = ({ appointmentId, csrfToken, onBack, onSaved }) => {
  const [meeting, setMeeting] = useState(null);
  const [options, setOptions] = useState([]);
  const [code, setCode] = useState("");
  const [note, setNote] = useState("");
  const [interests, setInterests] = useState([]);
  const [nextStep, setNextStep] = useState("");
  const [reason, setReason] = useState("");
  const [registrationUrl, setRegistrationUrl] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [correctionMode, setCorrectionMode] = useState(false);
  useEffect(() => {
    Promise.all([api.get(`/appointments/${appointmentId}`), api.get("/outcomes")]).then(([detail, vocabulary]) => {
      setMeeting(detail.data); setOptions(vocabulary.data.options);
      setCode(detail.data.outcome_code || ""); setNote(detail.data.outcome_code ? "" : detail.data.outcome_note || "");
      setInterests((detail.data.interests || []).map((item) => ({ id: item.id, quantity: item.quantity })));
      setNextStep(detail.data.next_step || "");
    }).catch((e) => setError(errorMessage(e)));
  }, [appointmentId]);
  const future = meeting && new Date(meeting.starts_at).getTime() + meeting.duration_minutes * 60_000 > Date.now();
  const otherParticipant = Boolean(meeting?.outcome_code && (!meeting?.can_correct || !correctionMode));
  const submit = async (event) => {
    event.preventDefault(); setBusy(true); setError("");
    try {
      if (otherParticipant) {
        await api.post(`/appointments/${appointmentId}/notes`, { note: note.trim() },
          { headers: { "X-CSRF-Token": csrfToken } });
        onSaved({ outcome_code: "note", venue_id: meeting.venue_id });
      } else {
        const { data } = await api.patch(`/appointments/${appointmentId}/outcome`, {
          code, note: note.trim(), interests: PRODUCT_CODES.includes(code) ? interests : [],
          next_step: code === "interested" ? nextStep : null,
          reason: code === "not_interested" ? reason : null,
          yollo_registration_url: code === "enrolled" ? registrationUrl || null : null,
        }, { headers: { "X-CSRF-Token": csrfToken } });
        onSaved({ ...data, participant_ids: meeting.participant_ids, meeting_number: meeting.meeting_number });
      }
    } catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <form className="outcome-form" onSubmit={submit} data-testid="outcome-form">
    <button type="button" className="sheet-back" onClick={onBack} data-testid="outcome-back-button">‹ Indietro</button>
    <h2 className="sheet-title" data-testid="outcome-title">{otherParticipant ? "Aggiungi una nota" : "Com'è andato l'incontro?"}</h2>
    {meeting && <><p className="outcome-venue" data-testid="outcome-venue-name">{meeting.venue_name} · {meeting.meeting_number}° incontro</p>
      <p className="outcome-date" data-testid="outcome-meeting-date">{new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", dateStyle: "medium", timeStyle: "short" }).format(new Date(meeting.starts_at))}</p>
      {meeting.outcome_code && <p className="call-pending" data-testid="outcome-recorded-label">Esito registrato: {meeting.outcome}{meeting.can_correct ? " · puoi correggerlo" : ""}</p>}
      {meeting.outcome_code && meeting.can_correct && <button type="button" className="text-action"
        onClick={() => { setCorrectionMode(!correctionMode); setNote(correctionMode ? "" : meeting.outcome_note || ""); }}
        data-testid="outcome-correction-toggle">{correctionMode ? "Aggiungi solo una nota" : "Correggi esito ›"}</button>}
      {!otherParticipant && <div className="outcome-choices" role="group" aria-label="Esito incontro" data-testid="outcome-options">
        {options.map((item) => <button type="button" key={item.code} className={code === item.code ? "active" : ""}
          aria-pressed={code === item.code} onClick={() => setCode(item.code)}
          data-testid={`outcome-option-${item.code.replaceAll("_", "-")}`}>{item.label}</button>)}
      </div>}
      {!otherParticipant && PRODUCT_CODES.includes(code) && <CatalogPicker value={interests} onChange={setInterests} />}
      {!otherParticipant && code === "interested" && <div className="form-field"><label htmlFor="outcome-next-step">PROSSIMO PASSO</label>
        <select id="outcome-next-step" required value={nextStep} onChange={(e) => setNextStep(e.target.value)}
          data-testid="outcome-next-step"><option value="">Seleziona</option><option value="demo">Demo ai soci</option>
          <option value="closing">Chiusura</option></select></div>}
      {!otherParticipant && code === "not_interested" && <div className="form-field"><label htmlFor="outcome-reason">MOTIVO</label>
        <select id="outcome-reason" required value={reason} onChange={(e) => setReason(e.target.value)}
          data-testid="outcome-reason"><option value="">Seleziona</option>{REASONS.map(([key, label]) =>
          <option value={key} key={key}>{label}</option>)}</select></div>}
      {!otherParticipant && code === "enrolled" && <div className="form-field"><label htmlFor="outcome-registration-url">LINK ISCRIZIONE YOLLO · FACOLTATIVO</label>
        <input id="outcome-registration-url" type="url" value={registrationUrl} onChange={(e) => setRegistrationUrl(e.target.value)}
          data-testid="outcome-registration-url" /></div>}
      <div className="form-field"><label htmlFor="meeting-outcome-note">NOTA</label><textarea id="meeting-outcome-note"
        className="hud-textarea" maxLength={2000} required value={note} onChange={(e) => setNote(e.target.value)}
        data-testid="outcome-note-input" /></div>
      {future && <p className="form-error" data-testid="outcome-future-message">L'incontro non è ancora terminato.</p>}
      {error && <p role="alert" className="form-error" data-testid="outcome-error">{error}</p>}
      <Button className="hud-button" type="submit" disabled={busy || future || !note.trim() ||
        (!otherParticipant && (!code || (PRODUCT_CODES.includes(code) && !interests.length) ||
          (code === "interested" && !nextStep) || (code === "not_interested" && !reason)))}
        data-testid="outcome-save-button">{busy ? "Salvataggio…" : otherParticipant ? "Aggiungi nota"
          : code === "interested" && meeting.meeting_number === 1 ? "Salva e fissa il 2° incontro"
            : ["busy", "not_present", "rescheduled"].includes(code) ? "Salva e sposta" : "Salva esito"}</Button></>}
  </form>;
};